// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3EaRq","fullView":"styles_fullView__1jPdR"};